import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import skills from './skills';

const state = () => ({
    workspacesList: [],
    workspace: {},
    generalActions: [],
    selectedAction: null,
    workspaceSessions: [],
    workspacePrompts: [],
    selectedPrompt: {},
    workspaceKnowledgeFiles: [],
    artifactList: [],

    isWorkspacesListLoading: false,
    isWorkspaceLoading: false,
    isWorkspaceSessionsLoading: false,
    isSendMessageLoading: false,
    isWorkspaceUpdateLoading: false,
    isUpdateParticipantsLoading: false,
    isWorkspacePromptsLoading: false,
    isWorkspaceActionLoading: false,
    isWorkspaceKnowledgeFileLoading: false,
    isDeleteWorkspaceLoading: false,
    isArtifactListLoading: false,
});

export default {
    namespaced: true,
    actions,
    mutations,
    state,
    getters,
    modules: {
        skills,
    },
};
